window.inExitProcess = false;
window.batteryObject = null;
window.exitBackoffice = function(quit)
{
	if (window.boxmethods != null)
	{
		if (!inExitProcess)
		{
			window.inExitProcess = true;
			crearVentanaEspera(null);

			window.boxmethods.executesAsynchronousFunction('exitRegister', null, 'emptyCallBack');

			setTimeout(function(){
				window.location.href = "logout" + (quit ? "?quit=true" : "");
			}, 1000);
		}
	}
	else
	{
		window.location.href = "logout";
	}

}


export function getBatteryInfo ()
{
	navigator.getBattery().then(function(batObject) { window.batteryObject = (batObject.level * 100) });
	if (window.boxmethods != null)
	{
		window.boxmethods.trackPosActivity(userId, null, null, null, null);
	}
}

window.setPosSystemInfo = function (configHardware, configLocal, activityDataJson)
{

	let objConfigHardware = JSON.parse(configHardware);
	if (window.batteryObject != null)
	{
		objConfigHardware.battery = window.batteryObject;
	}

	objConfigHardware.height = window.screen.height;
	objConfigHardware.width = window.screen.width;
	objConfigHardware.language = navigator.language;
	objConfigHardware.ram = navigator.deviceMemory;
	let deviceName = objConfigHardware.deviceName;

	let systemInfoJson = JSON.stringify(objConfigHardware);

	let posSystem = new PosSystem();

	posSystem.posName = deviceName;

	posSystem.systemInfo = systemInfoJson;
	posSystem.configLocal = configLocal;

	let configPosId = getParametroConfigTaquilla("posId");
	if (configPosId != null)
	{
		posSystem.posId = configPosId;
	}

	if (activityDataJson != null && activityDataJson != '[]')
	{
		let activityData = JSON.parse(activityDataJson);
		BackofficeAjax.sendPosSystemInfo(posSystem, activityData, completePosSystemInfo);
	}
	else
	{
		BackofficeAjax.sendPosSystemInfo(posSystem, null, completePosSystemInfo);
	}
}

window.completePosSystemInfo = function (checkedPosSystem)
{
	if (getParametroConfigTaquilla("posId") == null && checkedPosSystem.posId != null)
	{
		setParametroConfigTaquilla("posId", checkedPosSystem.posId.toString(), false);
	}

	return checkedPosSystem;
}

window.registerPosSystemInfo = function ()
{
	if (window.boxmethods != null)
	{
		window.boxmethods.executesAsynchronousFunction('registerPosSystemInfo', null, 'emptyCallBack');
	}
}

window.emptyCallBack = function()
{

}